/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SupportReportRequestDto } from '../models';
// @ts-ignore
import type { SupportReportResponseDto } from '../models';
/**
 * RestSupportApi - axios parameter creator
 */
export const RestSupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zgłoszenie błędu z aplikacji. Trafia do Intake projektu w Plane razem z kontekstem technicznym i opcjonalnym załącznikiem; w CRM zostaje po nim krótkie ukryte zadanie z linkiem do zgłoszenia. 
         * @summary Report an application issue
         * @param {string} userId 
         * @param {SupportReportRequestDto} supportReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSupportIssue: async (userId: string, supportReportRequestDto: SupportReportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('reportSupportIssue', 'userId', userId)
            // verify required parameter 'supportReportRequestDto' is not null or undefined
            assertParamExists('reportSupportIssue', 'supportReportRequestDto', supportReportRequestDto)
            const localVarPath = `/api/support/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supportReportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestSupportApi - functional programming interface
 */
export const RestSupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestSupportApiAxiosParamCreator(configuration)
    return {
        /**
         * Zgłoszenie błędu z aplikacji. Trafia do Intake projektu w Plane razem z kontekstem technicznym i opcjonalnym załącznikiem; w CRM zostaje po nim krótkie ukryte zadanie z linkiem do zgłoszenia. 
         * @summary Report an application issue
         * @param {string} userId 
         * @param {SupportReportRequestDto} supportReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportSupportIssue(userId: string, supportReportRequestDto: SupportReportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportReportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportSupportIssue(userId, supportReportRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSupportApi.reportSupportIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestSupportApi - factory interface
 */
export const RestSupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestSupportApiFp(configuration)
    return {
        /**
         * Zgłoszenie błędu z aplikacji. Trafia do Intake projektu w Plane razem z kontekstem technicznym i opcjonalnym załącznikiem; w CRM zostaje po nim krótkie ukryte zadanie z linkiem do zgłoszenia. 
         * @summary Report an application issue
         * @param {string} userId 
         * @param {SupportReportRequestDto} supportReportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSupportIssue(userId: string, supportReportRequestDto: SupportReportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupportReportResponseDto> {
            return localVarFp.reportSupportIssue(userId, supportReportRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestSupportApi - interface
 */
export interface RestSupportApiInterface {
    /**
     * Zgłoszenie błędu z aplikacji. Trafia do Intake projektu w Plane razem z kontekstem technicznym i opcjonalnym załącznikiem; w CRM zostaje po nim krótkie ukryte zadanie z linkiem do zgłoszenia. 
     * @summary Report an application issue
     * @param {string} userId 
     * @param {SupportReportRequestDto} supportReportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportSupportIssue(userId: string, supportReportRequestDto: SupportReportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupportReportResponseDto>;

}

/**
 * RestSupportApi - object-oriented interface
 */
export class RestSupportApi extends BaseAPI implements RestSupportApiInterface {
    /**
     * Zgłoszenie błędu z aplikacji. Trafia do Intake projektu w Plane razem z kontekstem technicznym i opcjonalnym załącznikiem; w CRM zostaje po nim krótkie ukryte zadanie z linkiem do zgłoszenia. 
     * @summary Report an application issue
     * @param {string} userId 
     * @param {SupportReportRequestDto} supportReportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportSupportIssue(userId: string, supportReportRequestDto: SupportReportRequestDto, options?: RawAxiosRequestConfig) {
        return RestSupportApiFp(this.configuration).reportSupportIssue(userId, supportReportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

